import { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import {
  isAuthenticated,
  addAcademicSession,
} from "../../../ApiService/ApiService";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import CustomDialog from "../../../Components/CustomDialog";

function AddSession({ fetchSessions, setShowAddSession }) {
  const schoolId = parseInt(sessionStorage.getItem("schoolId"));
  const [formData, setFormData] = useState({
    name: "",
    isCurrent: false,
    schoolId: schoolId,
    startDate: "",
    endDate: "",
  });
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setFormData({ ...formData, [name]: newValue });
  };

  const handleDialogClose = () => {
    setDialog({ ...dialog, visible: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Please fill all the details",
        buttons: [{ name: "OK", onPress: handleDialogClose }],
      });
      return;
    }
    setLoading(true);
    try {
      if (isAuthenticated()) {
        const response = await addAcademicSession(formData);
        // console.log("RES", response);
        if (response) {
          if (response?.data?.status === 200) {
            setDialog({
              visible: true,
              title: "Success",
              message: "Academic session added",
              buttons: [{ name: "OK", onPress: handleDialogClose }],
            });
            setFormData({
              name: "",
              isCurrent: false,
              schoolId: schoolId,
              startDate: "",
              endDate: "",
            });
            fetchSessions();
            setShowAddSession(false);
          } else {
            const errorMessage =
              response?.data?.errorMessage || "Something went wrong";
            setDialog({
              visible: true,
              title: "Error",
              message: errorMessage,
              buttons: [{ name: "Close", onPress: handleDialogClose }],
            });
          }
        } else {
          setDialog({
            visible: true,
            title: "Error",
            message: "Invalid response from the server",
            buttons: [{ name: "Close", onPress: handleDialogClose }],
          });
        }
      } else {
        setDialog({
          visible: true,
          title: "Unauthorized action",
          message: "Please login and try again",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
      }
    } catch (error) {
      console.log("Failed to add academic session", error);
      setDialog({
        visible: true,
        title: "Error",
        message: "Failed to add academic session",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomDialog
        visible={dialog.visible}
        title={dialog.title}
        message={dialog.message}
        buttons={dialog.buttons}
        onClose={handleDialogClose}
      />
      <Box sx={{ maxWidth: "75%", margin: "auto", padding: 3 }}>
        <Paper elevation={3} sx={{ padding: 5 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 600, fontSize: 22, color: "black" }}
          >
            Add Academic Session
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography sx={{ fontSize: 14, mb: 1, ml: 1 }}>
                  Start Date *
                </Typography>
                <TextField
                  fullWidth
                  name="startDate"
                  type="date"
                  labelid="startDate"
                  value={formData.startDate}
                  onChange={handleChange}
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography sx={{ fontSize: 14, mb: 1, ml: 1 }}>
                  End Date *
                </Typography>
                <TextField
                  fullWidth
                  name="endDate"
                  type="date"
                  labelid="endDate"
                  value={formData.endDate}
                  onChange={handleChange}
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isCurrent"
                      checked={formData.isCurrent}
                      onChange={handleChange}
                    />
                  }
                  label="Current Session"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Button
                  fullWidth
                  variant="contained"
                  color="inherit"
                  onClick={() => setShowAddSession(false)}
                  startIcon={<ArrowBack />}
                  sx={{ textTransform: "unset" }}
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  endIcon={<ArrowForward />}
                  sx={{ textTransform: "unset" }}
                >
                  {loading ? "Loading..." : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </>
  );
}

export default AddSession;
